import { useLayoutEffect, useRef } from 'react';
import { SlidersHorizontal } from '@phosphor-icons/react';
import { useIslandActions, useIslandState } from '../IslandProvider';
import { FARBE } from '../pille-stil';

const UNTEN = 16; // Abstand unter dem Inhalt

/**
 * Deck-Seite „Steuerung“: zeigt die vom Bereich registrierte Steuerung (Widgets).
 * Misst die Inhaltshöhe, damit die Pille passend wächst (gedeckelt auf den Viewport, dann scrollt sie).
 */
export function ControlsPage() {
  const { pageControls, pageLabel } = useIslandState();
  const { setControlsContentHeight } = useIslandActions();
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const push = () => {
      const h = el.offsetHeight;
      if (h > 0) setControlsContentHeight(h + UNTEN);
    };
    push();
    const observer = new ResizeObserver(push);
    observer.observe(el);
    return () => {
      observer.disconnect();
      setControlsContentHeight(null);
    };
  }, [pageControls, setControlsContentHeight]);

  // Vertikal scrollbar; kollidiert nicht mit dem Deck-Wischen (nur horizontale Gesten, Touch pan-y).
  return (
    <div className="h-full w-full overflow-y-auto overflow-x-clip overscroll-contain" style={{ padding: `0 16px ${UNTEN}px` }}>
      <div ref={ref} className="flex w-full flex-col" style={{ gap: 10 }}>
        {pageControls ? (
          <>
            {pageLabel && (
              <span className="flex items-center uppercase" style={{ gap: 6, fontSize: 12, fontWeight: 800, letterSpacing: '0.04em', color: 'rgba(235,235,245,0.6)', padding: '0 4px' }}>
                <SlidersHorizontal size={13} weight="bold" color={FARBE.gold} />{pageLabel} steuern
              </span>
            )}
            {pageControls}
          </>
        ) : (
          <div className="flex flex-col items-center justify-center" style={{ gap: 8, padding: '32px 0', color: 'rgba(235,235,245,0.5)' }}>
            <SlidersHorizontal size={24} />
            <span style={{ fontSize: 13, fontWeight: 600 }}>Keine Steuerung für diese Seite</span>
          </div>
        )}
      </div>
    </div>
  );
}
